import { ofType } from "redux-observable";
import { catchError, map, mergeMap, of } from "rxjs";
import { fetchSODConflicts } from "../../../../common/SODUtils/SODservices";
import {
  actionTypes,
  getAllRecoveryPointUsersFailureAction,
  getAllRecoveryPointUsersSuccessAction,
  entitlementRequestFailure,
  entitlementRequestSuccess,
  getPerDateAbilitationsSuccess,
  getPerDateAbilitationsFailure,
  createRequestSuccess,
  createRequestFailure,
  sodConflictsActionSuccess,
  sodConflictsActionFailure,
} from "./actions";
import {
  fetchCreateRequest,
  fetchDateEntitlementRequest,
  fetchGetAllUsers,
  fetchUserEntitlementRequest,
} from "./services";

const fetchGetAllUsersEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ALL_RECOVERY_POINT_USERS),
    mergeMap((action: any) =>
      fetchGetAllUsers(action.payload).pipe(
        map((response: any) => getAllRecoveryPointUsersSuccessAction(response)),
        catchError((error: any) =>
          of(getAllRecoveryPointUsersFailureAction(error))
        )
      )
    )
  );

const fetchEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.RECOVERY_POINT_USERS_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      fetchUserEntitlementRequest(action.id).pipe(
        map((response: any) => entitlementRequestSuccess(response)),
        catchError((error: any) => of(entitlementRequestFailure(error)))
      )
    )
  );

const fetchDateEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.RECOVERY_POINT_GET_DATE_ABILITATIONS),
    mergeMap((action: any) =>
      fetchDateEntitlementRequest(
        action.payload.userCode,
        action.payload.timeStamp
      ).pipe(
        map((response: any) => getPerDateAbilitationsSuccess(response)),
        catchError((error: any) => of(getPerDateAbilitationsFailure(error)))
      )
    )
  );

const fetchCreateRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.RECOVERY_POINT_CREATE_REQUEST),
    mergeMap((action: any) =>
      fetchCreateRequest(action.abilitationObj).pipe(
        map(() => createRequestSuccess()),
        catchError((error: any) => of(createRequestFailure(error)))
      )
    )
  );

const fetchSODConflictsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.RECOVERY_SOD_CONFLICTS),
    mergeMap((action: any) =>
      fetchSODConflicts(action.payload).pipe(
        map((response: any) => sodConflictsActionSuccess(response)),
        catchError((error: any) => of(sodConflictsActionFailure(error)))
      )
    )
  );

export default [
  fetchGetAllUsersEpic,
  fetchEntitlementRequestEpic,
  fetchDateEntitlementRequestEpic,
  fetchCreateRequestEpic,
  fetchSODConflictsEpic,
];
